import { __zcAsy, __zcFin, __zcFinZ, __zcMkv } from "__zod-compiler-runtime__";
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import * as z from 'zod'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'

/**
 * Schema for resource summary data displayed on index/listing pages.
 * This is the summarized representation of a resource shown in cards,
 * as opposed to the full resource details shown on individual pages.
 */
export const ResourceSummarySchema = /* @__PURE__ */ (() => {
var __zs=z.object({
  heading: z.string().optional(),
  image: safeOptional(
    z
      .object({
        description: z.string().optional().nullable(),
        url: z.string().optional().nullable(),
      })
      .nullable(),
  ),
  path: z.string().optional(),
  description: safeOptional(RichTextSchema.nullable()),
});
var __rf=[__zs.shape["image"]._zod.def.innerType._zod.def.out._zod.def.transform,__zs.shape["description"]._zod.def.innerType._zod.def.out._zod.def.transform];
var __bf_1={};
var __rfn_7=__rf[0];
var __rfn_11=__rf[1];
function __vb_2(input){var __bv_3,__bv_4,__bv_5,__bx_6,__bw_8,__bv_9,__bx_10,__bw_12,__bo_13;if(typeof input!=="object"||input===null||Array.isArray(input))return __bf_1;__bv_3=input["heading"];if(!((__bv_3===undefined||(typeof __bv_3==="string"))))return __bf_1;__bv_4=input["path"];if(!((__bv_4===undefined||(typeof __bv_4==="string"))))return __bf_1;__bv_5=input["image"];if(__bv_5===undefined){__bw_8=undefined;}else{__bx_6=__rfn_7(__bv_5);if(__bx_6 instanceof Promise)__zcAsy();__bw_8=__bx_6;}__bv_9=input["description"];if(__bv_9===undefined){__bw_12=undefined;}else{__bx_10=__rfn_11(__bv_9);if(__bx_10 instanceof Promise)__zcAsy();__bw_12=__bx_10;}__bo_13={};if(__bv_3!==undefined||("heading" in input)){__bo_13["heading"]=__bv_3;}if(__bw_8!==undefined||("image" in input)){__bo_13["image"]=__bw_8;}if(__bv_4!==undefined||("path" in input)){__bo_13["path"]=__bv_4;}if(__bw_12!==undefined||("description" in input)){__bo_13["description"]=__bw_12;}return __bo_13;}
var __rfm_z=__zs.safeParse;
function safeParse_ResourceSummarySchema(input){
var __bd_14=__vb_2(input);
if(__bd_14!==__bf_1){return{success:true,data:__bd_14};}
return __zcFinZ(__rfm_z,__zs,input);
}
return __zcMkv(safeParse_ResourceSummarySchema,__zs,null,null);
})()

export type ResourceSummary = z.infer<typeof ResourceSummarySchema>
